import axios from 'axios';
import Vue from 'vue';
import zenscroll from 'zenscroll';
import Errors from '../classes/errors';
import {
    checkCCM19Consent,
    checkOneTrustConsent,
    handleCloseDropdownOnBlur,
    handleLoadSharpsringScriptUrl,
    handleSetSharpspringScript,
    handleSharpspringSubmit,
    setCaptchaEuScript,
} from '../utils';

Vue.component('newsletter-form-component', {
    props: {
        siteHandle: {
            value: String,
        },
        sharpspringBaseUrl: {
            value: String,
        },
        sharpspringEndpointId: {
            value: String,
        },
        sharpspringScriptUrl: {
            value: String,
        },
        captchaEuPublicKey: {
            value: String,
        },
        isCaptchaEuEnabled: {
            value: Boolean,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            dropdownCountry: null,
            countryHandle: null,

            dropdownHeardFrom: null,
            heardFrom: null,
        };
    },

    computed: {
        toggleButtonLoadingClass() {
            return this.submitting ? 'button--loading' : '';
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }
        handleSetSharpspringScript(
            this.siteHandle,
            this.sharpspringBaseUrl,
            this.sharpspringEndpointId,
            'newsletterForm',
        );
        handleLoadSharpsringScriptUrl(
            this.siteHandle,
            this.sharpspringScriptUrl,
        );
        setCaptchaEuScript();

        handleCloseDropdownOnBlur('#heard-from-dropdown');
        handleCloseDropdownOnBlur('#country-dropdown');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        scrollToFirstError() {
            Vue.nextTick(() => {
                let firstError = document.querySelector(
                    '.new-input__container--error',
                );
                zenscroll.center(firstError);
            });
        },

        scrollToTop() {
            Vue.nextTick(() => {
                zenscroll.toY(0);
            });
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;

            let formData = new FormData(form);
            const data = {};

            for (let [key, val] of formData.entries()) {
                Object.assign(data, { [key]: val });
            }

            if (this.submitting) {
                return;
            }
            this.submitting = true;

            const newsletterDataLayer = {
                event: 'newsletter',
                user_data: {
                    email_address: data.emailAddress,
                    address: {
                        first_name: data.firstName,
                        last_name: data.lastName,
                        postal_code: data.zipCode,
                    },
                },
            };
            try {
                if (!this.isCaptchaEuEnabled) {
                    await this.handleDataSubmit(form, newsletterDataLayer);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(
                    form,
                    newsletterDataLayer,
                    captchaSolution,
                );
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, newsletterDataLayer, captchaSolution) {
            try {
                const formData = new FormData(form);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const response = await axios.post('/', formData);
                const result = response.data;

                if (result.data.errors) {
                    this.errors.clear();
                    this.errors.record(result.data.errors);

                    this.scrollToFirstError();
                    return;
                }

                // Success
                this.errors.clear();

                this.sendGTMData(newsletterDataLayer);
                handleSharpspringSubmit(
                    this.siteHandle,
                    this.sharpspringEndpointId,
                );

                window.location = this.$refs.redirectUrl.value;
            } catch (e) {
                throw new Error(e);
            }
        },

        sendGTMData(extraDataToPush) {
            const country =
                this.siteHandle == 'default'
                    ? 'mgMotorsEurope'
                    : this.siteHandle;

            if (checkCCM19Consent() || checkOneTrustConsent()) {
                // check if you are on production-enviroment
                if (!window.dataLayer) {
                    window.dataLayer = window.dataLayer || [];
                }

                if (extraDataToPush) {
                    window.dataLayer.push(extraDataToPush);
                }

                window.dataLayer.push({
                    event: 'newsletters',
                    model: ' ',
                    edition: ' ',
                    page_path: window.location.href,
                    country: `${country} - ${this.$root.languageCode}`,
                });
            }
        },

        setDropdownCountry(event) {
            this.dropdownCountry = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.countryHandle = value;
        },

        setDropdownHeardFrom(event) {
            event.preventDefault();
            // Set text property to show value in template, set value in heardFrom property to send along with the form.
            this.dropdownHeardFrom = event.currentTarget.dataset.text;
            this.heardFrom = event.currentTarget.dataset.value;

            // Close the dropdown.
            this.toggleDropdown(event);
        },

        toggleDropdown(event) {
            event.preventDefault();
            let element = event.currentTarget;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },
    },
});
